export default "__VITE_ASSET__f0c6f4f9__"